var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.document && _vm.document.insertions)?_c('div',_vm._l((_vm.uniqueQuotationNumbers),function(quotationNumber,key){return _c('div',{key:key},[_c('simple-text',{attrs:{"content":quotationNumber,"title":quotationNumber}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }